export default "__VITE_ASSET__BhYdCRBU__"